<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
  >
    <coupon-form ref="form" v-model="form" :input-errors="inputErrors" @save="create"/>
  </crud-create>
</template>

<script>

import CouponProvider from "../../../../providers/CouponProvider";

import {CrudCreate, ClientError} from '@dracul/common-frontend'

import CouponForm from "../../../../forms/CouponForm";


export default {
  name: "CouponCreate",

  components: {CouponForm, CrudCreate},

  props: {
    open: {type: Boolean, default: true}
  },

  data() {
    return {
      title: 'delivery.coupon.creating',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      form: {
        code: '',
        description: '',
        discountType: '',
        discountValue: null,
        minimumOrderAmount: null,
        startDate: null,
        expirationDate: null,
        maxTotalUses: null,
        active: true,
        paymentMethods: []
      }
    }
  },

  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true
        CouponProvider.createCoupon(this.form).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createCoupon)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }

  },
}
</script>

<style scoped>

</style>

